import './Badge.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d",
    "badge": "Badge_badge__t6n4b",
    "iconPadLeft": "Badge_iconPadLeft__t6n4b",
    "bordered": "Badge_bordered__t6n4b",
    "info": "Badge_info__t6n4b",
    "opportunity": "Badge_opportunity__t6n4b",
    "success": "Badge_success__t6n4b",
    "warning": "Badge_warning__t6n4b",
    "danger": "Badge_danger__t6n4b",
    "bold": "Badge_bold__t6n4b"
};
